import axios from 'axios'
import { CANCELAR_ENCOMENDA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cancelarEncomenda (motivo, idEmpresa, idEncomenda) {
  const url = `${URL}/encomendas/cancelar`;
  return dispatch => axios.post(url,{ motivo, idEmpresa, idEncomenda} , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CANCELAR_ENCOMENDA,
        payload: response
      })
  );
}
